"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYoutubeId = void 0;
var getYoutubeId = function (url) {
    var split = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== split[2] ? split[2].split(/[^0-9a-z_\-]/i)[0] : split[0];
};
exports.getYoutubeId = getYoutubeId;
var parseVideoSrcElements = document.querySelectorAll("[data-parse-video-src]");
parseVideoSrcElements &&
    parseVideoSrcElements.forEach(function (element) {
        var youtubeId = exports.getYoutubeId(element.getAttribute("data-parse-video-src"));
        if (youtubeId) {
            var src = "https://www.youtube.com/embed/" + youtubeId;
            element.setAttribute("src", src);
        }
        else {
            console.error("Parse video src: Error finding YouTube video ID");
            element.style.display = "none";
        }
    });
